import React, { useCallback } from 'react'
import { bool } from 'prop-types'
import { A, Button } from '@rebrandly/styleguide'

import { redirectToSignUp } from '../utils/auth'
import { getLinksFromCookie } from '../utils/common'

import config from '../config'

const FreeTrialButton = ({ children, isQr, ...rest }) => {
  const handleBuyNow = useCallback(() => {
    const { redirectToSignUp } = require('../utils/auth')

    const validLinks = getLinksFromCookie(isQr)

    const redirectUrl = redirectToSignUp && redirectToSignUp({
      category: 'FREETRIAL', // This query param is what makes the .NET OAuth proj to change the Left Side of the HTML
      links:  validLinks.map(link => ({ id: link.id })),
      isFREETrial: true,
      plan: config.freeTrialPlanId
    });
    return window.open(redirectUrl, '_blank')
  },[isQr])

  return (
    <>
      {children && <A onClick={handleBuyNow} target='_blank' rel='noopener noreferrer' {...rest}>{children}</A>}
      {!children && <Button onClick={handleBuyNow} {...rest} />}
    </>
  )
}

FreeTrialButton.propTypes = {
  isQr: bool
}

export default FreeTrialButton
